import { z } from 'zod';
import { _ } from 'svelte-i18n';
import { ResolutionDate } from './ResolutionDate';
import { ResolutionToday } from './ResolutionToday';
// import { SliderDateSettings } from '../../../Dashboard/AvailableWidgets/Status/SliderDateSettings';

export class RelativeSliderSettingsOrNot {
    public static getRelativeDateFromDate(dateYYYYMMDD: string): string {
        let dateObj = Math.floor(new Date(dateYYYYMMDD).setHours(12) / (1000 * 60 * 60 * 24));
        let today = Math.floor(new Date().setHours(12) / (1000 * 60 * 60 * 24));
        let diff = dateObj - today;
        return 'today:' + (diff > 0 ? '+' + diff : diff);
    }

    public static getRelativeDateFromDays(days_diff: number): string {
        return 'today:' + (days_diff > 0 ? '+' + days_diff : days_diff);
    }

    public static isDateRelative(
        dateFrom: string | number | boolean,
        dateTo: string | number | boolean
    ): boolean {
        if (typeof dateFrom === 'number' || typeof dateTo === 'number') {
            if (typeof dateFrom === 'number' && dateFrom < 1000) {
                return true;
            }
            if (typeof dateTo === 'number' && dateTo < 1000) {
                return true;
            }
            return false;
        }
        if (typeof dateFrom === 'boolean' || typeof dateTo === 'boolean') {
            return false;
        }
        return (
            dateFrom.toLocaleLowerCase().indexOf('today:') === 0 &&
            dateTo.toLocaleLowerCase().indexOf('today:') === 0
        );
    }

    private static getDateStringDaysDiff(date: string, daysDiff: number): string {
        let dateObj = new Date(date);
        dateObj.setDate(dateObj.getDate() + daysDiff);
        return dateObj.toISOString().split('T')[0];
    }

    // public static getSettings2(
    //     sliderDataSettings: SliderDateSettings,
    //     flagOnZero: string = '',
    //     unit: string = 'dni'
    // ) {
    //     let defaultDayMaxRange = 14;
    //     if (sliderDataSettings.dateRelative) {
    //         let relative1 = sliderDataSettings.getRelativeDays1();
    //         let relative2 = sliderDataSettings.getRelativeDays2();
    //         return {
    //             min:
    //                 typeof relative1 === 'number'
    //                     ? relative1 - defaultDayMaxRange
    //                     : -defaultDayMaxRange,
    //             max:
    //                 typeof relative2 === 'number'
    //                     ? relative2 + defaultDayMaxRange
    //                     : defaultDayMaxRange,
    //             currentValue1: sliderDataSettings.getRelativeDays1(),
    //             currentValue2: sliderDataSettings.getRelativeDays2(),
    //             unit: unit,
    //             roundValues: true,
    //             dangerZoneBelowValue: false,
    //             dangerZoneAboveValue: false,
    //             resolution: 'today',
    //             resolutionValue: 1,
    //             flagOnZero: flagOnZero,
    //         };
    //     } else {
    //         let dateFrom = sliderDataSettings.getAbsoluteDays1OrFalse();
    //         let dateTo = sliderDataSettings.getAbsoluteDays2OrFalse();
    //         let rangeDateFrom: number =
    //             typeof dateFrom === 'number'
    //                 ? dateFrom - 7
    //                 : ResolutionDate.getDaysFromDate(new Date()) - 14;
    //
    //         let rangeDateTo: number =
    //             typeof dateTo === 'number'
    //                 ? dateTo + 7
    //                 : ResolutionDate.getDaysFromDate(new Date()) + 14;
    //
    //         // if (typeof dateFrom === 'number' && rangeDateFrom > dateFrom) {
    //         //     rangeDateFrom = dateFrom;
    //         // }
    //         // if (typeof dateFrom === 'number' && rangeDateTo < dateFrom) {
    //         //     rangeDateTo = dateFrom;
    //         // }
    //         // if (typeof dateTo === 'number' && rangeDateFrom > dateTo) {
    //         //     rangeDateFrom = dateTo;
    //         // }
    //         // if (typeof dateTo === 'number' && rangeDateTo < dateTo) {
    //         //     rangeDateTo = dateTo;
    //         // }
    //
    //         return {
    //             min: rangeDateFrom,
    //             max: rangeDateTo,
    //             currentValue1: dateFrom, // ex: 32121 (days from 1970-01-01)
    //             currentValue2: dateTo, // ex: 32123 (days from 1970-01-01)
    //             unit: '',
    //             roundValues: true,
    //             dangerZoneBelowValue: false,
    //             dangerZoneAboveValue: false,
    //             // dangerZoneBelowValue: ResolutionDate.getDaysFromDate(new Date(rangeDateFrom)), // ResolutionDate.getDaysFromDate(new Date(dateFrom)),
    //             // dangerZoneAboveValue: ResolutionDate.getDaysFromDate(new Date(rangeDateTo)), // ResolutionDate.getDaysFromDate(new Date(dateTo)),
    //             resolution: 'date',
    //             resolutionValue: 1,
    //             flagOnZero: '',
    //         };
    //     }
    // }

    public static getSettings(
        dateRelative: boolean,
        rangeDateFrom: string | number,
        rangeDateTo: string | number,
        dateFrom: string | number | boolean,
        dateTo: string | number | boolean,
        flagOnZero: string = '',
        unit: string = 'dni'
    ) {
        let defaultDayMaxRange = 14;
        if (dateRelative) {
            return {
                min: -defaultDayMaxRange,
                max: defaultDayMaxRange,
                currentValue1:
                    typeof dateFrom === 'string'
                        ? ResolutionToday.getDaysFromTodayString(dateFrom)
                        : dateFrom,
                currentValue2:
                    typeof dateTo === 'string'
                        ? ResolutionToday.getDaysFromTodayString(dateTo)
                        : dateTo,
                unit: unit,
                roundValues: true,
                dangerZoneBelowValue: -100,
                dangerZoneAboveValue: 100,
                resolution: 'today',
                resolutionValue: 1,
                flagOnZero: flagOnZero,
            };
        } else {
            let defaultDateFrom14DaysBeforeToday = new Date(
                new Date().getTime() - defaultDayMaxRange * 24 * 60 * 60 * 1000
            )
                .toISOString()
                .split('T')[0];
            let defaultDateTo14DaysAfterToday = new Date(
                new Date().getTime() + defaultDayMaxRange * 24 * 60 * 60 * 1000
            )
                .toISOString()
                .split('T')[0];
            rangeDateFrom = z
                .string()
                .regex(/^\d{4}-\d{2}-\d{2}$/)
                .catch(defaultDateFrom14DaysBeforeToday)
                .parse(rangeDateFrom);
            rangeDateTo = z
                .string()
                .regex(/^\d{4}-\d{2}-\d{2}$/)
                .catch(defaultDateTo14DaysAfterToday)
                .parse(rangeDateTo);
            dateFrom = z
                .string()
                .regex(/^\d{4}-\d{2}-\d{2}$/)
                .catch(defaultDateFrom14DaysBeforeToday)
                .parse(dateFrom);
            dateTo = z
                .string()
                .regex(/^\d{4}-\d{2}-\d{2}$/)
                .catch(defaultDateTo14DaysAfterToday)
                .parse(dateTo);
            return {
                min: ResolutionDate.getDaysFromDate(new Date(rangeDateFrom)),
                max: ResolutionDate.getDaysFromDate(new Date(rangeDateTo)),
                currentValue1: false, // ResolutionDate.getDaysFromDate(new Date(dateFrom)),
                currentValue2: false, // ResolutionDate.getDaysFromDate(new Date(dateTo)),
                unit: '',
                roundValues: true,
                dangerZoneBelowValue: ResolutionDate.getDaysFromDate(new Date(rangeDateFrom)), // ResolutionDate.getDaysFromDate(new Date(dateFrom)),
                dangerZoneAboveValue: ResolutionDate.getDaysFromDate(new Date(rangeDateTo)), // ResolutionDate.getDaysFromDate(new Date(dateTo)),
                resolution: 'date',
                resolutionValue: 1,
                flagOnZero: '',
            };
        }
    }
}
